import React from "react"
//import I18n from "i18n-js/index.js.erb"
import clsx from "clsx"
import DateHelper from "../../DateHelper/DateHelper"




class DatesAndTimesPresenterGeneral extends React.Component {
	constructor(props) {
		super(props)
	}

	render() {
		var tabClasses = clsx({
			'active': this.props.active_tab == 'general',
			'tab-pane': true,
		})

		var us_time_zone_names = []
		var dateFormat = DateHelper.rubyToDateJS(this.props.date_format)

		return (
			<div className={tabClasses} id="general">
				<div className="row active tab-pane">
					<div className="col-md-4">
						<div className="form-group">
							<label style={{ marginRight: "4px" }}>{I18n.t("date_format")}</label>
							<span className="ss-help help" title={I18n.t("default_date_format_helper_text")}></span>
							<br />
							{this.props.date_format ? this.props.date_format : I18n.t("please_select")}
						</div>
					</div>

					<div className="col-md-4">
						<div className="form-group">
                            <label style={{ marginRight: "4px" }}>  {I18n.t("time_format")} </label>
							<span className="ss-help help" title={I18n.t("default_time_format_helper_text")}></span>
							<br />
							{this.props.time_format ? this.props.time_format : I18n.t("please_select")}
						</div>
					</div>

					<div className="col-md-4">
						<div className="form-group">
                            <label style={{ marginRight: "4px" }}>  {I18n.t("time_zone")} </label>
							<span className="ss-help help" title={I18n.t("default_time_zone_helper_text")}></span>
							<br />
							{this.props.time_zone ? this.props.time_zone : I18n.t("please_select")}
						</div>
					</div>
				</div>

				<div className="card">
					{I18n.t("formats_for_the_date_components")}: <br/><br/>
					<ul>
						{/* <li>yy – two-digit year, e.g. 96</li> */}
						<li>yyyy – four-digit year, e.g. 1996</li>
						<li>m – one-digit month for months below 10, e.g. 4</li>
						<li>mm – two-digit month, e.g. 04</li>
						<li>mmm – three-letter abbreviation for month, e.g. Apr</li>
						<li>mmmm – month spelled out in full, e.g. April</li>
						<li>d – one-digit day for days below 10, e.g. 2</li>
						<li>dd – two-digit day, e.g. 02</li>
					</ul>
					<br/>
					{I18n.t("separators_of_the_date_components")}: <br/><br/>
					<ul>
						<li>"/" – slash</li>
						<li>"." – dots or full stops</li>
						<li>"-" – hyphens or dashes</li>
						<li>" " – spaces</li>
					</ul>
					<br/>
					{I18n.t("formats_for_the_time_components")}:<br/><br/>
					<ul>
						<li>H – one-digit hour, 24-hour clock, for hours below 10, e.g. 4</li>
						<li>HH - two-digit hour, 24-hour clock, e.g. 14</li>
						<li>h – one-digit hour for hours below 10, e.g. 4</li>
						<li>hh - two-digit hour, e.g. 04</li>
						<li>m - one-digit minute for minutes below 10, e.g. 7</li>
						<li>mm - two-digit minute, e.g. 07</li>
						<li>p - Meridian indicator, lowercase (e.g. am or pm)</li>
						<li>P - Meridian indicator, uppercase (e.g. AM or PM)</li>
					</ul>
					<br/>
					{I18n.t("separators_of_the_time_components")}:<br/><br/>
					<ul>
						<li>":" – colon</li>
						<li>" " – spaces</li>
					</ul>
				</div>
			</div>
		);
	}
}

export default DatesAndTimesPresenterGeneral
